// extracted by mini-css-extract-plugin
export default {"cls1":"fjlv1CuwZjn8JImW1pLX","cls2":"E3YeB7yhpRNfPvYBnw3A fjlv1CuwZjn8JImW1pLX"};